import React from 'react';
import {useRecoilState} from 'recoil';
import DatePickerBase from "@components/datePicker/DatePickerBase";
import {memberUpdateState, userFilterState} from "@pages/userManage/atoms";

type Props = {
    name: string
};

const DatePicker: React.FC<Props> = ({name}: Props) => {
    const [state, setState] = useRecoilState(memberUpdateState);

    return (
            <DatePickerBase name={name} state={state} setState={setState}/>
    );
};

export default DatePicker;
